import { defineStore, storeToRefs } from "pinia";
import { FallbackCurrencyId, type CurrencyId } from "@/services/currencies/currenciesTypes";
import type { CountryCode } from "@/services/translation";
import { type LanguageId } from "@/services/translation";
import { readonly } from "vue";

const useAppPiniaStore = defineStore("appStore", () => {
  const currencyId = ref<CurrencyId>(FallbackCurrencyId);
  const languageId = ref<LanguageId | undefined>(undefined);
  const countryCode = ref<CountryCode | undefined>(undefined);
  const isStartupUserCheckDone = ref(false);

  const setStartupUserCheckDone = () => {
    isStartupUserCheckDone.value = true;
  };

  const setCurrencyId = (id: CurrencyId) => {
    currencyId.value = id;
  };

  const setCountryCode = (code: CountryCode) => {
    countryCode.value = code;
  };

  const setLanguageId = (id: LanguageId) => {
    languageId.value = id;
  };

  return {
    currencyId,
    languageId,
    countryCode,
    isStartupUserCheckDone,
    setCountryCode,
    setCurrencyId,
    setLanguageId,
    setStartupUserCheckDone,
  };
});

export function useAppStore() {
  const store = useAppPiniaStore();
  const { currencyId, languageId, countryCode, isStartupUserCheckDone } = storeToRefs(store);

  return {
    currencyId: readonly(currencyId),
    languageId: readonly(languageId),
    countryCode: readonly(countryCode),
    isStartupUserCheckDone: readonly(isStartupUserCheckDone),
    setCountryCode: store.setCountryCode,
    setCurrencyId: store.setCurrencyId,
    setLanguageId: store.setLanguageId,
    setStartupUserCheckDone: store.setStartupUserCheckDone,
  };
}
